import script from "./PageNotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&setup=true&lang=ts"

import "./PageNotFound.vue?vue&type=style&index=0&id=436eab26&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Diogo Neves Pereira\\Desktop\\QS\\Monitur\\monitur-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436eab26"]])

export default __exports__